import styles from './FormikStyles.module.scss';

function TextError(props: any): JSX.Element {
  return <div className={styles.errorHint}>{props.children}</div>;
}

export default TextError;
